import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ValidadorFechasService {

  constructor() { 
    // This is intentional
  }

  MayorDeAños(min: number) {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value !== null && control.value.trim().length > 0) // && (isNaN(control.value) || control.value < 20 || control.value > 70))
      {
        const _now = new Date()
        const now = moment([_now.getFullYear(), _now.getMonth(), _now.getDate()])
        const bornDate = moment(control.value)
        const diff = now.diff(bornDate, 'years', true)
        if (diff >= min)
          return null
        return { 'MayorDeAños': true }
      }
      return null;
    };
  }

  EntreAños(min: number, max: number) {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value !== null && control.value.trim().length > 0) // && (isNaN(control.value) || control.value < 20 || control.value > 70))
      {
        const _now = new Date()
        const now = moment([_now.getFullYear(), _now.getMonth(), _now.getDate()])
        const bornDate = moment(control.value)
        const diff = now.diff(bornDate, 'years', true)
        if (min <= diff && diff < max) {
          return null;
        }
        return { 'EntreAños': true }
      }
      return null;
    };
  }
}
